import { useApi } from '@/api';
import { Page } from '@/components';
import {
  Flex,
  Heading,
  CryptoIcon,
  Card,
  EmptyBox,
  BlankNotepadIcon,
  KpiCard
} from '@blockanalitica/ui';
import { useParams } from 'react-router';
import DebtAssetSankeyChart from './DebtAssetSankeyChart';
import DebtAssetHistoricBarChart from './DebtAssetHistoricBarChart';

type Debt = {
  date: string;
  underlying_address: string;
  underlying_symbol: string;
  underlying_name: string | null;
  total_collateral: string | null;
  total_debt: string | null;
  total_collateral_change: string | null;
  total_debt_change: string | null;
  total_collateral_change_percentage: string | null;
  total_debt_change_percentage: string | null;
};

export default function DebtPage() {
  const { marketAddress, network } = useParams() as {
    marketAddress: string;
    network: string;
  };
  const [data, error] = useApi<Debt>({
    url: `/markets/${marketAddress}/debt/`
  });

  if (error) {
    throw error;
  }

  if (!data || Object.keys(data).length === 0) {
    return (
      <EmptyBox
        icon={<BlankNotepadIcon />}
        message={`This debt asset has no debt`}
      />
    );
  }
  const title = (
    <Flex gap="xs">
      <CryptoIcon
        name={data.underlying_symbol}
        address={marketAddress}
        network={network}
        size="5"
      />
      <Heading>{`Collateral Backing ${data.underlying_symbol} Debt`}</Heading>
    </Flex>
  );
  return (
    <Page title={title}>
      <KpiCard
        title={`Total collateral backing ${data.underlying_symbol} debt`}
        data={data}
        field="total_collateral"
        options={{
          trend: true,
          variants: { valuePercentageValue: 'dynamic' },
          currency: 'USD'
        }}
      />
      <Card gap="3xs" flexBasis="50%">
        <DebtAssetSankeyChart marketAddress={marketAddress} />
      </Card>
      <Card gap="3xs" flexDirection="column">
        <DebtAssetHistoricBarChart marketAddress={marketAddress} />
      </Card>
    </Page>
  );
}
